import type { FunctionComponent, PropsWithChildren } from "react";

import Button from "~/components/buttons/Button";
import Hint from "~/components/Hint";


const SidebarErrorOverlay: FunctionComponent<PropsWithChildren<{
	onDismiss?: () => void;
	title: string
}>> = ({ onDismiss, title, children }) =>
	(<div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-100/50 ">
		<div className="mx-10 my-8 flex flex-col items-center justify-center gap-y-4 rounded-lg bg-white p-4 shadow">
			<Hint theme="error"
				  title={title}>
				{children}
			</Hint>
			{onDismiss && <Button theme="primary" onClick={onDismiss}>Schließen</Button>}
		</div>

	</div>);
export default SidebarErrorOverlay;